import { waitForPendo } from './setup';
export function trackPendo(eventName, trackData) {
  waitForPendo().then(function (pendo) {
    console.log('[track]', eventName, trackData);
    pendo.track(eventName, trackData);
  });
}
export default trackPendo;